'use strict';

var wraptile = require('wraptile/legacy');

var store = require('fullstore/legacy');

var createElement = require('@cloudcmd/create-element');

var showTitle = require('./show-title');

var query = require('./query');

var indexStore = store();
var helpersStore = store();
var next = wraptile(function (img, images) {
  return setImage(indexStore() + 1, img, images);
});
var prev = wraptile(function (img, images) {
  return setImage(indexStore() - 1, img, images);
});
var onload = wraptile(function (parent, afterShow) {
  parent.hidden = false;
  afterShow();
});

var onKeydown = function onKeydown(img, images) {
  return function keydownListener(e) {
    var i = indexStore();
    var ArrowLeft = 37;
    var ArrowRight = 39;
    var Esc = 27;
    var keyCode = e.keyCode;
    if (keyCode === ArrowLeft) --i;else if (keyCode === ArrowRight) ++i;else if (keyCode === Esc) return document.body.removeEventListener('keydown', keydownListener);else return;
    setImage(i, img, images);
  };
};

function setImage(i, img, images) {
  var n = images.length - 1;
  if (i < 0 || i > n) return;
  indexStore(i);
  query('nav-left').hidden = !i;
  query('nav-right').hidden = i === n;
  var _images$i = images[i],
      href = _images$i.href,
      title = _images$i.title;
  img.src = href;
  img.title = title;
  img.href = title;
  img.alt = title;
  if (helpersStore().title) showTitle(title, query('child'));
}

module.exports = parseImages;

function parseImages(parent, images, _ref) {
  var afterShow = _ref.afterShow,
      helpers = _ref.helpers,
      index = _ref.index;
  indexStore(index);
  helpersStore(helpers);
  var img = createImage();
  parent.appendChild(img);
  parent.hidden = true;
  parent.appendChild(createElement('div', {
    className: 'modal-nav modal-nav-left',
    dataName: 'modal-nav-left',
    innerHTML: '<span></span>'
  }));
  parent.appendChild(createElement('div', {
    className: 'modal-nav modal-nav-right',
    dataName: 'modal-nav-right',
    innerHTML: '<span data-name="modal-next"></span>'
  }));
  setImage(index, img, images);
  addListenerOnce(img, 'load', onload(parent, afterShow));
  query('nav-left').addEventListener('click', prev(img, images));
  query('nav-right').addEventListener('click', next(img, images));
  document.body.addEventListener('keydown', onKeydown(img, images));
}

function createImage() {
  var el = document.createElement('img');
  el.className = 'modal-image';
  return el;
}

module.exports._rmListener = rmListener;

function rmListener(el, name, fn) {
  return function f(e) {
    fn(e);
    el.removeEventListener(name, f);
  };
}

module.exports._addListenerOnce = addListenerOnce;

function addListenerOnce(el, name, fn) {
  el.addEventListener(name, rmListener(el, name, fn));
}

module.exports._onKeydown = onKeydown;
module.exports._indexStore = indexStore;
module.exports._helpersStore = helpersStore;
module.exports._onload = onload;